<template>
  <div class="wrap" style="text-align:center;">
    请选择科普分类
  </div>
</template>
<style  lang="less" scoped>

</style>
<script>
export default {
  name: "",
  data() {
    return {
      start: 0,
      limit: 10,
      categoryId: "",
      tagList: [],
      articleList: [],
      hasNext: true
    };
  },
  mounted: function() {
    
  },
  methods: {
    
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/emptyPage.vue